import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		marginTop: THEME.spacing.md,
	},
	headerLabel: {
		display: 'block',
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		fontWeight: THEME.typography.fontWeights.semibold,
		textTransform: 'uppercase' as const,
		letterSpacing: '0.05em',
		marginBottom: THEME.spacing.sm,
	},
	toggleRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.sm,
	},
	toggleLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		cursor: 'pointer',
		userSelect: 'none' as const,
	},
	attachmentList: {
		display: 'flex',
		flexWrap: 'wrap' as const,
		gap: THEME.spacing.sm,
		marginBottom: THEME.spacing.sm,
	},
	attachmentItem: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		background: THEME.colors.background.main,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.main,
	},
	removeButton: {
		color: THEME.colors.text.light,
		lineHeight: 1,
		':hover': {
			color: THEME.colors.danger.main,
		},
	},
	addButton: {
		fontSize: THEME.typography.fontSizes.sm,
		textDecoration: 'underline',
	},
	uploadingRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		marginBottom: THEME.spacing.sm,
	},
	warningText: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.warning.main,
		marginTop: THEME.spacing.xs,
	},
	infoText: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		marginTop: THEME.spacing.xs,
	},
});
